/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const Pencil: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5144 3.97381C15.9334 3.80026 16.3824 3.71094 16.8359 3.71094C17.2894 3.71094 17.7385 3.80026 18.1575 3.97381C18.5765 4.14737 18.9572 4.40174 19.2779 4.72242C19.5986 5.0431 19.8529 5.42381 20.0265 5.8428C20.2 6.26179 20.2894 6.71086 20.2894 7.16436C20.2894 7.61787 20.2 8.06694 20.0265 8.48593C19.8529 8.90492 19.5986 9.28563 19.2779 9.60631L18.279 10.6052C18.2786 10.6056 18.2783 10.6059 18.2779 10.6063C18.2775 10.6067 18.2771 10.6071 18.2767 10.6074L8.77788 20.1063C8.66067 20.2235 8.5017 20.2894 8.33594 20.2894H4.33594C3.99076 20.2894 3.71094 20.0095 3.71094 19.6644V15.6644C3.71094 15.4986 3.77679 15.3396 3.894 15.2224L14.394 4.72242C14.7147 4.40174 15.0954 4.14737 15.5144 3.97381ZM13.8359 7.04825L4.96094 15.9232V19.0394H8.07705L16.9521 10.1644L13.8359 7.04825ZM17.8359 9.28048L14.7198 6.16437L15.2779 5.60631C15.4825 5.4017 15.7254 5.2394 15.9927 5.12866C16.2601 5.01793 16.5466 4.96094 16.8359 4.96094C17.1253 4.96094 17.4118 5.01793 17.6792 5.12866C17.9465 5.2394 18.1894 5.4017 18.394 5.60631C18.5986 5.81091 18.7609 6.05382 18.8716 6.32115C18.9824 6.58848 19.0394 6.875 19.0394 7.16436C19.0394 7.45372 18.9824 7.74025 18.8716 8.00758C18.7609 8.27491 18.5986 8.51782 18.394 8.72242L17.8359 9.28048Z"
      fill={color}
    />
  </svg>
)
